import { createSlice } from '@reduxjs/toolkit';

export const postSlice = createSlice({
    name: 'post',
    initialState: {
        loading: true,
        demo_loading: true,
        data: {},
        main_data: {},
        post_data: [],
        error: false,
        uploadInProgress: false,
        uploadProgress: 0,
        uploadStatusText: '',
        uploadSizeInfo: null,
    },
    reducers: {
        POST_FETCH_START: (state) => {
            state.loading = true
        },
        POST_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.demo_loading = false
            state.data = action.payload
            state.main_data = action.payload
            state.post_data = action.payload.get_posts
        },
        POST_FETCH_SUCCESS_LOAD: (state, action) => {
            state.loading = false
            state.main_data = action.payload
            state.data = action.payload
            state.post_data = [...state.post_data, ...action.payload.get_posts]
        },
        ADD_POST_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.post_data = [action.payload, ...state.post_data]
        },
        EDIT_POST_FETCH_SUCCESS: (state, action) => {
            console.log(action.payload);
            state.loading = false;
            const updatedPostIndex = state.post_data.findIndex(post => post.id === action.payload.id);
            if (updatedPostIndex !== -1) {
                const updatedPostArray = [...state.post_data];
                updatedPostArray[updatedPostIndex] = action.payload;
                state.post_data = updatedPostArray;
            }
        },
        POST_FETCH_COMMENT_ADDON: (state, action) => {
            state.loading = false
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? { ...post, totalComments: (post.totalComments || 0) + 1, last_comments: [...post.last_comments, action.payload] }
                    : post
            )
        },


        DELETE_COMMENT: (state, action) => {
            const Post = state.post_data.find(
                (pst) => pst.id === action.payload.post_id
            );

            Post.last_comments.filter((com) => com.id !== action.payload.comment_id);
            state.loading = false
            state.post_data = state.post_data.map((pst) =>
                pst.id === action.payload.post_id ? Post : pst
            )
        },

        DELETE_POST: (state, action) => {
            const filterPosts = state.post_data.filter(
                (post) => post.id !== action.payload
            );
            state.loading = false
            state.post_data = filterPosts
        },

        ADD_REPLY: (state, action) => {
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? {
                        ...post,
                        last_comments: post.last_comments.map((comment) =>
                            comment.id === action.payload.comment_id
                                ? { ...comment, comment_reply: [...(comment.comment_reply || []), action.payload] }
                                : comment
                        )
                    }
                    : post
            )
        },

        DELETE_REPLY: (state, action) => {
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? {
                        ...post,
                        last_comments: post.last_comments.map((com) =>
                            com.id === action.payload.comment_id
                                ? { ...com, comment_reply: (com.comment_reply || []).filter(reply => reply.id !== action.payload.comment_reply_id) }
                                : com
                        )
                    }
                    : post
            )
        },

        POST_FETCH_ERROR: (state) => {
            state.error = true
        },
        POST_LIKE_UPDATE: (state, action) => {
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? { ...post, totalLikes: action.payload.likes_count, is_like: action.payload.is_like }
                    : post
            )
        },
        UPLOAD_START: (state) => {
            state.uploadInProgress = true;
            state.uploadProgress = 1;
            state.uploadStatusText = 'Compressing...';
            state.uploadSizeInfo = null;
        },
        UPLOAD_PROGRESS: (state, action) => {
            if (action.payload.progress !== undefined) state.uploadProgress = action.payload.progress;
            if (action.payload.statusText !== undefined) state.uploadStatusText = action.payload.statusText;
            if (action.payload.sizeInfo !== undefined) state.uploadSizeInfo = action.payload.sizeInfo;
        },
        UPLOAD_DONE: (state) => {
            state.uploadInProgress = false;
            state.uploadProgress = 0;
            state.uploadStatusText = '';
            state.uploadSizeInfo = null;
        }
    }
});

export const { EDIT_POST_FETCH_SUCCESS, POST_FETCH_START, DELETE_REPLY, ADD_POST_FETCH_SUCCESS, POST_FETCH_ERROR, POST_FETCH_SUCCESS, POST_FETCH_SUCCESS_LOAD, POST_FETCH_COMMENT_ADDON, ADD_REPLY, DELETE_COMMENT, DELETE_POST, POST_LIKE_UPDATE, UPLOAD_START, UPLOAD_PROGRESS, UPLOAD_DONE } = postSlice.actions;
export default postSlice.reducer;